export default __webpack_public_path__ + "static/media/mail-icon.a9512ce5.svg";